import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { apiPost } from "../../api";
import { printShippingLabels } from "../../labelFlow";
import { useTicketContext } from "./useTicket";

/** Print Shipping Labels and Replace Shipping Labels for the open ticket. */
export function useLabels() {
  const { config, detail, reload, notify } = useTicketContext();
  const auth = useAuth();
  const token = auth.user?.id_token ?? "";
  const no = detail.ticket.ticketNo;
  const [busy, setBusy] = useState<string | null>(null);

  const print = () => {
    const tab = window.open("", "_blank");
    setBusy("Checking labels…");
    notify(null);
    printShippingLabels(config, token, [no], tab, setBusy)
      .then((text) => notify(text))
      .catch((e: Error) => notify(`Labels: ${e.message}`))
      .finally(() => { setBusy(null); reload(); });
  };

  const replace = () => {
    if (!window.confirm(`Replace the shipping labels for #${no}?\n\nBoth current labels (to the customer and the spare return label) are voided and a refund is requested from Shippo, then new labels are bought and printed. Throw away the old printed labels.`)) return;
    const tab = window.open("", "_blank");
    setBusy("Replacing labels…");
    notify(null);
    apiPost<{ refunds: string[]; problems: { ticketNo: number; error: string }[] }>(config, token, "/tickets/actions/replace-labels", { ticketNos: [no] })
      .then(async (r) => {
        if (r.problems.length) { tab?.close(); notify(`Old labels voided, but new ones could not be bought: ${r.problems.map((p) => p.error).join("; ")}`); return; }
        const text = await printShippingLabels(config, token, [no], tab, setBusy);
        notify(`Old labels voided (refund ${r.refunds.join(", ").toLowerCase() || "not needed"}). ${text}`);
      })
      .catch((e: Error) => { tab?.close(); notify(`Labels: ${e.message}`); })
      .finally(() => { setBusy(null); reload(); });
  };

  return { busy, print, replace };
}
